import React from 'react';
import classes from './NavigationItem.module.css';
import {NavLink} from 'react-router-dom';


const NavigationItem = (props) => (
    <li className={classes.NavigationItem}>
        <NavLink to={props.link} 
            activeStyle={props.active ? classes.active : {}}>
        <span className="material-icons">{props.icon}</span>
        <span>{props.children}</span></NavLink>
    </li>
);

export default NavigationItem;